import { ReactNode } from 'react';
import OfferCheckoutView, { OfferCheckoutViewData } from '../../../offer-checkout/components/offer-checkout-view/offer-checkout-view';
import { useElementWidth } from '../../hooks/use-element-width';

// The checkout is rendered at a desktop size and scaled down to the available width.
const PREVIEW_WIDTH = 1280;
const PREVIEW_HEIGHT = 800;

export interface OfferPreviewFrameProps {
  /** `null` shows `placeholder` instead. */
  preview: OfferCheckoutViewData | null;
  termMonths: number | null;
  placeholder?: ReactNode;
}

/** The customer's checkout, read only (no `onSubmit`) – used by the live preview of the form and by the offer detail. */
const OfferPreviewFrame = ({ preview, termMonths, placeholder }: OfferPreviewFrameProps) => {
  // The frame's height follows its width via CSS (aspect ratio) – only the scale is computed, so measuring cannot loop.
  const { ref, width } = useElementWidth<HTMLDivElement>();

  return (
    <div ref={ref} className="relative aspect-[1280/800] w-full overflow-hidden rounded-2xl border border-[#E4E7EC] bg-white">
      {preview && termMonths !== null ? (
        <div
          className="absolute left-0 top-0 origin-top-left p-4"
          style={{ width: PREVIEW_WIDTH, height: PREVIEW_HEIGHT, transform: `scale(${width / PREVIEW_WIDTH})` }}>
          {/* Remounted when the prefill changes – the checkout form takes its defaults only once. */}
          <OfferCheckoutView key={JSON.stringify([preview.customer, preview.paymentMethod])} offer={preview} termMonths={termMonths} />
        </div>
      ) : (
        <div className="flex h-full items-center justify-center p-6 text-center text-[14px] text-[#888]">{placeholder}</div>
      )}
    </div>
  );
};

export default OfferPreviewFrame;
